export default __webpack_public_path__ + "static/media/lds-logo_lt.407a083266047c8e.svg";